import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';
import { throwErrorWithId } from '@pypestream/utils';
import { pickBy } from 'lodash';

import { checkForErrors } from '../../utils';
import { ProStudioContext, ProStudioEvents } from '../prostudio.xstate.types';
import type {
  SolutionVersion,
  SolutionVersionInput,
} from '@pypestream/api-services/urql';

// Drops '', null and undefined. `files` and `tasks` are arrays, never stripped,
// so the result is still a complete SolutionVersionInput.
const removeEmptyStrings = (
  version: SolutionVersionInput
): SolutionVersionInput =>
  pickBy(
    version,
    (value) => value !== '' && value !== null && value !== undefined
  ) as SolutionVersionInput;

export const updateSolution = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<{
  draftVersionSolutionData?: SolutionVersion;
  cb?: (
    updatedSolutionData: ProStudioContext['draftVersionSolutionData']
  ) => void;
} | void> => {
  if (event.type !== 'updateSolution') {
    return;
  }

  const { draftVersionSolutionData } = ctx;
  const { version, cb } = event.payload;

  if (!draftVersionSolutionData?.id) {
    throwErrorWithId('Solution version ID is required');
    return;
  }

  const updateSolutionVersionResponse = await urqlGql.updateSolutionVersion({
    version: {
      ...removeEmptyStrings(version),
      id: draftVersionSolutionData.id,
    },
  });

  checkForErrors(updateSolutionVersionResponse);

  const updatedSolutionData = updateSolutionVersionResponse.data?.admin_
    ?.updateSolutionVersion as SolutionVersion | undefined;

  return {
    draftVersionSolutionData: updatedSolutionData,
    cb: cb ? () => cb(updatedSolutionData as SolutionVersion) : undefined,
  };
};
